import { apiRequest } from './api'

export function adminSignIn(login, password) {
  return apiRequest('/admin/auth/signin', {
    method: 'POST',
    skipAuth: true,
    body: JSON.stringify({ login, password }),
  })
}

export function adminSignOut() {
  return apiRequest('/admin/auth/signout', {
    method: 'POST',
  })
}

export function adminRegister(payload) {
  return apiRequest('/admin/auth/register', {
    method: 'POST',
    skipAuth: true,
    body: JSON.stringify(payload),
  })
}

export function listAdminUsers() {
  return apiRequest('/admin/auth/users', {
    method: 'GET',
  })
}
